import * as React from 'react';

import Discount140 from './Discount140';

export const discount140 = () => <Discount140 />;

export default {
    title: 'Illustration/Discount140',
    component: Discount140,
    parameters: {
        notes: "`import Discount140 from 'box-ui-elements/es/illustration/Discount140';`",
    },
};
